/**
 * Sticky left column for the main product layout (desktop only).
 * Moves the product-details container (description) under the media inside [data-sticky-left], so media
 * and description form one position: sticky column next to the product info. Runs on load, on breakpoint
 * change and on theme editor section reloads — never on scroll. On mobile the container goes back to its
 * own section so the original order (media, info, description) is kept.
 */
(() => {
  const query = window.matchMedia('(min-width: 769px)');

  const sync = () => {
    document.querySelectorAll('[data-sticky-left]').forEach((left) => {
      const home = left.closest('.shopify-section')?.nextElementSibling;
      if (!home?.classList.contains('cc-product-details')) return;
      const fresh = home.querySelector(':scope > .container');
      const moved = left.querySelector(':scope > [data-moved-details]');
      // Editor re-rendered the details section: drop the stale copy.
      if (fresh && moved) moved.remove();
      const container = fresh || moved;
      if (!container) return;
      container.setAttribute('data-moved-details', '');
      if (query.matches) {
        if (container.parentElement !== left) left.appendChild(container);
      } else if (container.parentElement !== home) {
        home.appendChild(container);
      }
    });
  };

  query.addEventListener('change', sync);
  document.addEventListener('shopify:section:load', sync);
  sync();
})();
